export function changeDeviceStateName(stateName){
	let color = stateName.stateColor;
	if(stateName.stateName.indexOf('离线')!= -1){
		return {
			stateName:'terminal.offline',
			stateColor:color
		}
	}else if(stateName.stateName.indexOf('开屏')!= -1){
		return {
			stateName:'terminal.onscreen',
			stateColor:'#00ae00'
		}
	}else if(stateName.stateName.indexOf('关屏')!= -1){
		return {
			stateName:'terminal.action4',
			stateColor:'#00ae00'
		}
	}else if(stateName.stateName.indexOf('禁用')!= -1){
		return {
			stateName:'terminal.ban',
			stateColor:color
		}
	}else{
		return stateName
	}
}